import React, { useRef, useEffect, useState, useCallback  } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton'; 
import MenuItem  from "@mui/material/MenuItem";
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import FormSearchStores from "pages/forms/editOrNewFormDI/FormSearchStores";
import FormSearchStoresNimaAddresses from "pages/forms/editOrNewFormDI/FormSearchStoresNimaAddress";
import FormSearchStoresAddresses from "./FormSearchStoresAddress";
import FormSearchStoreVehicles from "./FormSearchVehicles";
import PropTypes from 'prop-types';

const initialPostalCodesToSelect = [{
    "id":0,
    "postalcode":"",
    "name":"",
    "postalcodename":"",
    "enabled":true,
    "province_id":0,
    "province_name":""
}];

const initialDocumentIdToSelect = [{
    "id": 0,
    "documentid": "",
    "tradename": ""
}];

const initialNimaToSelect = [{
    "id":0,
    "nima":""
}];

const FormCreateOrEditRespProd = ({formForm,setFormForm,setIsLoadingErrorData,errorsForm,setErrorsForm,validateFormForm,documentTypesToSelect,roadTypesToSelect,communityToSelect,expanded,optTypeToSelect,hasbeenshared}) => {
    const {t,i18n} = useTranslation(['listDataForms']);
    const token = useSelector((state) => state.loginUser.token); 
    const roles = useSelector((state) => state.loginUser.roles);  
    const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
    const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
    const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
    const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
    const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
    const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
    const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
    const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
    const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
    const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
    const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 
       
    const resp_prod_view_name = useSelector((state) => state.formatDIUser.resp_prod_view_name); 
    const resp_prod_view_contactname = useSelector((state) => state.formatDIUser.resp_prod_view_contactname); 
    const resp_prod_view_address = useSelector((state) => state.formatDIUser.resp_prod_view_address); 
    const resp_prod_view_phone = useSelector((state) => state.formatDIUser.resp_prod_view_phone); 
    const resp_prod_view_email = useSelector((state) => state.formatDIUser.resp_prod_view_email); 
    const resp_prod_view_nima = useSelector((state) => state.formatDIUser.resp_prod_view_nima); 
    const resp_prod_view_cnae = useSelector((state) => state.formatDIUser.resp_prod_view_cnae); 
    const resp_prod_view_inscription = useSelector((state) => state.formatDIUser.resp_prod_view_inscription); 
    const resp_prod_view_opt = useSelector((state) => state.formatDIUser.resp_prod_view_opt); 
    const resp_prod_view_licenseplate = useSelector((state) => state.formatDIUser.resp_prod_view_licenseplate); 
    const resp_prod_view_economicactivity = useSelector((state) => state.formatDIUser.resp_prod_view_economicactivity); 

    const resp_prod_handle_documnettype= useSelector((state) => state.formatDIUser.resp_prod_handle_documnettype); 
    const resp_prod_handle_documentid= useSelector((state) => state.formatDIUser.resp_prod_handle_documentid); 
    const resp_prod_handle_tradename= useSelector((state) => state.formatDIUser.resp_prod_handle_tradename); 
    const resp_prod_handle_name= useSelector((state) => state.formatDIUser.resp_prod_handle_name); 
    const resp_prod_handle_contactname= useSelector((state) => state.formatDIUser.resp_prod_handle_contactname); 
    const resp_prod_handle_address= useSelector((state) => state.formatDIUser.resp_prod_handle_address); 
    const resp_prod_handle_phone= useSelector((state) => state.formatDIUser.resp_prod_handle_phone); 
    const resp_prod_handle_email= useSelector((state) => state.formatDIUser.resp_prod_handle_email); 
    const resp_prod_handle_nima= useSelector((state) => state.formatDIUser.resp_prod_handle_nima); 
    const resp_prod_handle_cnae= useSelector((state) => state.formatDIUser.resp_prod_handle_cnae); 
    const resp_prod_handle_inscription= useSelector((state) => state.formatDIUser.resp_prod_handle_inscription); 
    const resp_prod_handle_opt= useSelector((state) => state.formatDIUser.resp_prod_handle_opt); 
    const resp_prod_handle_licenseplate= useSelector((state) => state.formatDIUser.resp_prod_handle_licenseplate); 
    const resp_prod_handle_economicactivity= useSelector((state) => state.formatDIUser.resp_prod_handle_economicactivity); 
    const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
    const [showModalSearchStoresAddress, setShowModalSearchStoresAddress] = useState(false); 
    const [showModalSearchStoresNimaAddress, setShowModalSearchStoresNimaAddress] = useState(false);     
    const [showModalSearchVehicles, setShowModalSearchVehicles] = useState(false); 
    const dispatch = useDispatch(); 
    const [postalCodeRespProdToSelect,setPostalCodeRespProdToSelect]= useState(initialPostalCodesToSelect);  
    const [filteredpostalCodeRespProd, setFilteredpostalCodeRespProd] = useState([]); // Opciones filtradas
    const [highlightedIndexPostalCodeRespProd, setHighlightedIndexPostalCodeRespProd] = useState(-1); // Índice de la opción resaltada 
    const [documentIdRespProdToSelect,setDocumentIdRespProdToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredDocumentIdRespProd, setFilteredDocumentIdRespProd] = useState([]); // Opciones filtradas
    const [highlightedIndexDocumentIdRespProd, setHighlightedIndexDocumentIdRespProd] = useState(-1); // Índice de la opción resaltada 
    const [tradenameRespProdToSelect,setTradenameRespProdToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredTradenamedRespProd, setFilteredTradenamedRespProd] = useState([]); // Opciones filtradas
    const [highlightedIndexTradenamedRespProd, setHighlightedIndexTradenamedRespProd] = useState(-1); // Índice de la opción resaltada 
    const [respProdNimaToSelect,setRespProdNimaToSelect]= useState(initialNimaToSelect);  
    const [filteredRespProdNima, setFilteredRespProdNima] = useState([]); // Opciones filtradas
    const [highlightedIndexRespProdNima, setHighlightedIndexRespProdNima] = useState(-1); // Índice de la opción resaltada 
         
    // Debounce helper
    const useDebounce = (callback, delay = 300) => {
        const timeoutRef = useRef(null);
        return useCallback((...args) => {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
            callback(...args);
            }, delay);
        }, [callback, delay]);
    };

    // Dentro del componente
    const debouncedHandleSearchPostalCode= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredpostalCodeRespProd([]);
            setHighlightedIndexPostalCodeRespProd(-1);
        return;
        }
        const filtered = postalCodeRespProdToSelect
        .filter(postal => postal && postal.postalcode)
        .filter(postal => {
            const postalcode = postal.postalcode.toUpperCase();
            return postalcode.startsWith(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredpostalCodeRespProd(filtered);
        setHighlightedIndexPostalCodeRespProd(0);
    }, 300); 
    const handleSelectPostalCodeRespProd = (postal) => {
        if (!postal) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
            ...formForm,
            resp_prod_postalcode_id: postal.id || Number(DEFAULTPOSTALCODE_ID),
            resp_prod_postalcode_code: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
            resp_prod_postalcode_name: postal.name || DEFAULTPOSTALCODE_NAME,
            resp_prod_province_id: postal.province_id || Number(DEFAULTPROVINCE),
            resp_prod_province_name: postal.province_name || DEFAULTPROVINCE_NAME
        }));
        setFilteredpostalCodeRespProd([]);
        setHighlightedIndexPostalCodeRespProd(-1);
    }; 
    const handleKeyDownDPostalCodeRespProd = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredpostalCodeRespProd.length === 0 && formForm.resp_prod_postalcode_code.trim() === "") {
            setHighlightedIndexPostalCodeRespProd(postalCodeRespProdToSelect);
            setHighlightedIndexPostalCodeRespProd(0);
        } else {
            setHighlightedIndexPostalCodeRespProd((prevIndex) => {
            const nextIndex = prevIndex < filteredpostalCodeRespProd.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexPostalCodeRespProd((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeRespProd >= 0) {
            if (highlightedIndexPostalCodeRespProd >= 0 && highlightedIndexPostalCodeRespProd < filteredpostalCodeRespProd.length) {
                handleSelectPostalCodeRespProd(filteredpostalCodeRespProd[highlightedIndexPostalCodeRespProd]);
            }
        } else if (event.key === "Escape") {
        const isValid = postalCodeRespProdToSelect.some((postal) => {
            if (!postal || !postal.postalcode) return false; 
            const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
            const normalizedInputId = formForm.resp_prod_postalcode_code.toUpperCase();
            return normalizedPostalCodeId === normalizedInputId;
        }); 
        if (!isValid) { 
            setFormForm((formForm) => ({
                ...formForm,
                resp_prod_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
                resp_prod_postalcode_code:  DEFAULTPOSTALCODE_CODE,
                resp_prod_postalcode_name: DEFAULTPOSTALCODE_NAME,
                resp_prod_province_id: Number(DEFAULTPROVINCE),
                resp_prod_province_name: DEFAULTPROVINCE_NAME
            }));
        } 
        setFilteredpostalCodeRespProd([]);
        setHighlightedIndexPostalCodeRespProd(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchDocumentIdResp = useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredDocumentIdRespProd([]);
            setHighlightedIndexDocumentIdRespProd(-1);
            return;
        }
        const filtered = documentIdRespProdToSelect
            .filter(store => store && store.documentid)
            .filter(store => {
            const documentId = store.documentid.toUpperCase();
            return documentId.includes(upperValue);
            })
            .slice(0, 20); // limitar resultados
        setFilteredDocumentIdRespProd(filtered);
        setHighlightedIndexDocumentIdRespProd(0);
    }, 300); 
    const handleSelectDocumentIdRespProd = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        resp_prod_documentid: store.documentid || "",
        }));
        setFilteredDocumentIdRespProd([]);
        setHighlightedIndexDocumentIdRespProd(-1);
    }; 
    const handleKeyDownDocumentIdRespProd = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredDocumentIdRespProd.length === 0 && formForm.resp_prod_documentid.trim() === "") {
            setFilteredDocumentIdRespProd(documentIdRespProdToSelect);
            setHighlightedIndexDocumentIdRespProd(0);
        } else {
            setHighlightedIndexDocumentIdRespProd((prevIndex) => {
            const nextIndex = prevIndex < filteredDocumentIdRespProd.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexDocumentIdRespProd((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdRespProd >= 0) {
        if (highlightedIndexDocumentIdRespProd >= 0 && highlightedIndexDocumentIdRespProd < filteredDocumentIdRespProd.length) {
            handleSelectDocumentIdRespProd(filteredDocumentIdRespProd[highlightedIndexDocumentIdRespProd]);
        }
        } else if (event.key === "Escape") {
        const isValid = documentIdRespProdToSelect.some((store) => {
            if (!store || !store.documentid) return false; 
            const normalizedStoreId = store.documentid.toUpperCase().replace(/[.-]/g, "");
            const normalizedInputId = formForm.resp_prod_documentid.toUpperCase();
            return normalizedStoreId === normalizedInputId;
        }); 
        if (!isValid) {
            setFormForm((formForm) => ({
            ...formForm,
            resp_prod_documentid: "",
            }));
        } 
        setFilteredDocumentIdRespProd([]);
        setHighlightedIndexDocumentIdRespProd(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchTradenameResp= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredTradenamedRespProd([]);
            setHighlightedIndexTradenamedRespProd(-1);
        return;
        }
        const filtered = tradenameRespProdToSelect
        .filter(store => store && store.tradename)
        .filter(store => {
            const tradename = store.tradename.toUpperCase();
            return tradename.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredTradenamedRespProd(filtered);
        setHighlightedIndexTradenamedRespProd(0);
    }, 300); 
    const handleSelectTradeNameRespProd = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        resp_prod_tradename: store.tradename || "",
        resp_prod_documentid: store.documentid || formForm.resp_prod_documentid,
        
        }));
        setFilteredTradenamedRespProd([]);
        setHighlightedIndexTradenamedRespProd(-1);
    }; 
    const handleKeyDownTradenameRespProd = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredTradenamedRespProd.length === 0 && formForm.resp_prod_tradename.trim() === "") {
            setFilteredTradenamedRespProd(tradenameRespProdToSelect);
            setHighlightedIndexTradenamedRespProd(0);
        } else {
            setHighlightedIndexTradenamedRespProd((prevIndex) => {
            const nextIndex = prevIndex < filteredTradenamedRespProd.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexTradenamedRespProd((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedRespProd >= 0) {
        if (highlightedIndexTradenamedRespProd >= 0 && highlightedIndexTradenamedRespProd < filteredTradenamedRespProd.length) {
            handleSelectTradeNameRespProd(filteredTradenamedRespProd[highlightedIndexTradenamedRespProd]);
        }
        } else if (event.key === "Escape") {
        const isValid = tradenameRespProdToSelect.some((store) => {
            if (!store || !store.tradename) return false; 
            const normalizedTradeName = store.tradename.toUpperCase();
            const normalizedInputTradeName = formForm.resp_prod_tradename.toUpperCase();
            return normalizedTradeName === normalizedInputTradeName;
        }); 
        if (!isValid) {
            setFormForm((formForm) => ({
            ...formForm,
            resp_prod_tradename: "",
            }));
        } 
        setFilteredTradenamedRespProd([]);
        setHighlightedIndexTradenamedRespProd(-1);
        }
    };

    // Dentro del componente
    const debouncedHandleSearchRespProdNima= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredRespProdNima([]);
            setHighlightedIndexRespProdNima(-1);
        return;
        }
        const filtered = respProdNimaToSelect
        .filter(nt => nt && nt.nima)
        .filter(nt => {
            const nima = nt.nima.toUpperCase();
            return nima.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredRespProdNima(filtered);
        setHighlightedIndexRespProdNima(0);
    }, 300); 
    const handleSelectRespProdNima = (nt) => {
        if (!nt) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        resp_prod_nima: nt.nima || ""
        }));
        setFilteredRespProdNima([]);
        setHighlightedIndexRespProdNima(-1);
    }; 
    const handleKeyDownRespProdNima = (event) => {
       if (event.key === "ArrowDown") {
            if (filteredRespProdNima.length === 0 && formForm.resp_prod_nima.trim() === "") {
                const filtered = respProdNimaToSelect.filter(nt => nt && nt.nima).slice(0, 20);
                setFilteredRespProdNima(filtered);
                setHighlightedIndexRespProdNima(0);
            } else {
                setHighlightedIndexRespProdNima((prevIndex) => {
                    const nextIndex = prevIndex < filteredRespProdNima.length - 1 ? prevIndex + 1 : prevIndex;
                    scrollToElement(nextIndex);
                    return nextIndex;
                });
            }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexRespProdNima((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexRespProdNima >= 0) {
            if (highlightedIndexRespProdNima >= 0 && highlightedIndexRespProdNima < filteredRespProdNima.length) {
                handleSelectRespProdNima(filteredRespProdNima[highlightedIndexRespProdNima]);
            }
        } else if (event.key === "Escape") {
            const isValid = respProdNimaToSelect.some((nt) => {
                if (!nt || !nt.nima) return false; 
                const normalizedPostalCodeId = nt.nima.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formForm.resp_prod_nima.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormForm((formForm) => ({
                ...formForm, 
                resp_prod_nima: ""
            }));
        } 
        setFilteredRespProdNima([]);
        setHighlightedIndexRespProdNima(-1);
        }
    };

    // Función para desplazar el contenedor
    const scrollToElement = (index) => {
        const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
        const item = dropdown?.children[index];
        if (item) {
        item.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
        });
        }
    };

    const handleBlur = useCallback((event) => {
        if (!event || !event.currentTarget) return;
        // Asegúrate de que no se cierra si haces clic en un elemento de la lista
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setFilteredpostalCodeRespProd([]);
            setHighlightedIndexPostalCodeRespProd(-1);
            setFilteredDocumentIdRespProd([]);
            setHighlightedIndexDocumentIdRespProd(-1);
            setFilteredTradenamedRespProd([]);
            setHighlightedIndexTradenamedRespProd(-1); 
            setFilteredRespProdNima([]);
            setHighlightedIndexRespProdNima(-1);  
        }
    }, []);

    const handleChangeSelectDocumentType_Resp_Prod = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            resp_prod_documnettype_id:event.target.value
        }));
    };
    const handleBlurSelectDocumentType_Resp_Prod = (e) => {
        handleChangeSelectDocumentType_Resp_Prod(e);
    };
    
    const handleChangeSelectRoadType_Resp_Prod = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            resp_prod_roadtype_id : event.target.value 
        }));
    };
    const handleBlurSelectRoadType_Resp_Prod = (e) => {
        handleChangeSelectRoadType_Resp_Prod(e);
        setErrorsForm(validateFormForm());
    };
       
    const handleChangeSelectCommunity_Resp_Prod = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            resp_prod_community_id : event.target.value   
        }));
    };
    const handleBlurSelectCommunity_Resp_Prod = (e) => {
        handleChangeSelectCommunity_Resp_Prod(e);
        setErrorsForm(validateFormForm());
    };

    const handleChangeDataEditForm_Resp_Prod = (e) => {
        const { name, value } = e.target;
        setFormForm(formForm => ({
          ...formForm,
          [name]: value,
        }));
    };
    const handleBlurDataEditForm_Resp_Prod = (e) => {
        handleChangeDataEditForm_Resp_Prod(e);
        setErrorsForm(validateFormForm());
    };
    
    const searchFormStore = (event) => {
        setShowModalSearchStores(true);
    };

    const searchFormStoreAddress = (event) => {
        setShowModalSearchStoresAddress(true);
    };

    const searchFormStoreNimaAddress = (event) => {
        setShowModalSearchStoresNimaAddress(true);
    };

    const searchFormVehicles = (event) => {
        setShowModalSearchVehicles(true);
    };

    const deleteDateRespProd = (event) => {
        setFormForm(formForm => ({
          ...formForm,
            resp_prod_store_id:0,
            resp_prod_documnettype_id: Number(DEFAULTTYPEOFDOCUMENT),
            resp_prod_documentid:"",
            resp_prod_tradename: "",
            resp_prod_name: "",
            resp_prod_contactname: "",
            resp_prod_roadtype_id: Number(DEFAULTROADTYE),
            resp_prod_street: "",
            resp_prod_country_id: Number(DEFAULTCOUNTRY),
            resp_prod_country_name:DEFAULTCOUNTRY_NAME,
            resp_prod_province_id: Number(DEFAULTPROVINCE),
            resp_prod_province_name:DEFAULTPROVINCE_NAME,
            resp_prod_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            resp_prod_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            resp_prod_postalcode_name: DEFAULTPOSTALCODE_NAME,
            resp_prod_community_id: Number(DEFAULTCOMMUNITY),
            resp_prod_community_name: DEFAULTCOMMUNITY_NAME,
            resp_prod_phone: "",
            resp_prod_email: "",
            resp_prod_nima: "",
            resp_prod_cnae: "",
            resp_prod_inscription: "",
            resp_prod_opt: 0,
            resp_prod_licenseplate: "",
            resp_prod_economicactivity:""
        }));
        setErrorsForm(validateFormForm());
        setErrorsForm(errorsForm => ({
            ...errorsForm,
            resp_prod_store_id:0,
            resp_prod_documnettype_id: "",
            resp_prod_documentid:"",
            resp_prod_tradename: "",
            resp_prod_name: "",
            resp_prod_contactname: "",
            resp_prod_roadtype_id: "",
            resp_prod_street: "",
            resp_prod_country_id: "",
            resp_prod_province_id: "",
            resp_prod_postalcode_id: "",
            resp_prod_postalcode_code:"",
            resp_prod_community_id: "",
            resp_prod_phone: "",
            resp_prod_email: "",
            resp_prod_nima: "",
            resp_prod_cnae: "",
            resp_prod_inscription: "",
            resp_prod_opt: "",
            resp_prod_licenseplate: "",
            resp_prod_economicactivity:""
        }));
    };

    const deleteDataSteetRespProd = (event) => {
        setFormForm(formForm => ({
          ...formForm,
            resp_prod_roadtype_id: Number(DEFAULTROADTYE),
            resp_prod_street: "",
            resp_prod_country_id: Number(DEFAULTCOUNTRY),
            resp_prod_country_name:DEFAULTCOUNTRY_NAME,
            resp_prod_province_id: Number(DEFAULTPROVINCE),
            resp_prod_province_name:DEFAULTPROVINCE_NAME,
            resp_prod_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
            resp_prod_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            resp_prod_postalcode_name: DEFAULTPOSTALCODE_NAME,
            resp_prod_community_id: Number(DEFAULTCOMMUNITY),
            resp_prod_community_name: DEFAULTCOMMUNITY_NAME,
            resp_prod_nima: "", 
            resp_prod_inscription: "",
            resp_prod_opt: 0
        }));
        setErrorsForm(validateFormForm());
    };

    const deleteDataVehicleRespProd = (event) => {
        setFormForm(formForm => ({
          ...formForm,
          resp_prod_licenseplate: ""
        }));
        setErrorsForm(validateFormForm());
    };

    useEffect(() => {
        let isMounted = true;
        const fetchExistNumberDocument = async () => {
            try {
              const getData = await helpHttp().get2(ENDPOINT,`form/getexiststorebynumberdocument/`,token,formForm.resp_prod_documentid.replace(/[.\-/\\|]/g, "").trim());
              if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                if (getData>0 && getData!==formForm.resp_prod_store_id){
                    fetchStoreNumberDocument();
                }
              }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
 
        const fetchStoreNumberDocument = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`form/getformstorebynumberdocument`,token,formForm.resp_prod_documentid.replace(/[.\-/\\|]/g, "").trim(),7);
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    if (getData!==undefined && getData!==null && getData!==""){
                        setFormForm(formForm => ({
                            ...formForm,
                            resp_prod_store_id: getData.store_id,
                            resp_prod_documnettype_id: (getData.documnettype_id===undefined 
                                                    || getData.documnettype_id===null  
                                                    || getData.documnettype_id===""
                                                    || getData.documnettype_id==="0"
                                                    || getData.documnettype_id===0)?
                                                    Number(DEFAULTTYPEOFDOCUMENT):getData.documnettype_id,
                            resp_prod_tradename: getData.tradename,
                            resp_prod_name: getData.name,
                            resp_prod_contactname: getData.contacperson,
                            resp_prod_roadtype_id: (getData.roadtype_id===undefined 
                                                    || getData.roadtype_id===null  
                                                    || getData.roadtype_id===""
                                                    || getData.roadtype_id==="0"
                                                    || getData.roadtype_id===0)?
                                                    Number(DEFAULTROADTYE):getData.roadtype_id,
                            resp_prod_street: getData.street,
                            resp_prod_country_id: (getData.country_id===undefined 
                                                    || getData.country_id===null  
                                                    || getData.country_id===""
                                                    || getData.country_id==="0"
                                                    || getData.country_id===0)?
                                                    Number(DEFAULTCOUNTRY):getData.country_id,
                            resp_prod_country_name: (getData.country_name===undefined 
                                                    || getData.country_name===null  
                                                    || getData.country_name==="" )?
                                                    DEFAULTCOUNTRY_NAME:getData.country_name,
                            resp_prod_province_id: (getData.province_id===undefined 
                                                    || getData.province_id===null  
                                                    || getData.province_id===""
                                                    || getData.province_id==="0"
                                                    || getData.province_id===0)?
                                                    Number(DEFAULTPROVINCE):getData.province_id,
                            resp_prod_province_name: (getData.province_name===undefined 
                                                    || getData.province_name===null  
                                                    || getData.province_name==="" )?
                                                    DEFAULTPROVINCE_NAME:getData.province_name, 
                            resp_prod_postalcode_id: (getData.postalcode_id===undefined 
                                                        || getData.postalcode_id===null  
                                                        || getData.postalcode_id===""
                                                        || getData.postalcode_id==="0"
                                                        || getData.postalcode_id===0)?
                                                        Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id,
                            resp_prod_postalcode_code: (getData.postalcode_code===undefined 
                                                        || getData.postalcode_code===null  
                                                        || getData.postalcode_code==="" )?
                                                         DEFAULTPOSTALCODE_CODE:getData.postalcode_code,
                            resp_prod_postalcode_name:   (getData.postalcode_name===undefined 
                                                        || getData.postalcode_name===null  
                                                        || getData.postalcode_name==="" )?
                                                         DEFAULTPOSTALCODE_NAME:getData.postalcode_name,                       
                            resp_prod_community_id: (getData.community_id===undefined 
                                                        || getData.community_id===null  
                                                        || getData.community_id===""
                                                        || getData.community_id==="0"
                                                        || getData.community_id===0)?
                                                        Number(DEFAULTCOMMUNITY):getData.community_id,
                            resp_prod_community_name:   (getData.community_name===undefined 
                                                        || getData.community_name===null  
                                                        || getData.community_name==="" )?
                                                         DEFAULTCOMMUNITY_NAME:getData.community_name,  
                            resp_prod_phone: getData.phone,
                            resp_prod_email: getData.email,
                            resp_prod_nima: getData.nima_resp_prod,
                            resp_prod_cnae: getData.cnae,
                            resp_prod_inscription: getData.pygr_resp_prod,
                            resp_prod_opt: getData.opt_resp_prod,
                            resp_prod_licenseplate: getData.licenseplate,
                            resp_prod_economicactivity:getData.economicactivity
                        }));
                    }  
                }         
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel7'){
            if (formForm.resp_prod_documentid && formForm.resp_prod_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
                fetchExistNumberDocument();
            } 
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,expanded,formForm.resp_prod_documentid,errorsForm.resp_prod_documentid,setIsLoadingErrorData,DEFAULTCOMMUNITY,DEFAULTCOUNTRY,DEFAULTPROVINCE,setFormForm,formForm.resp_prod_store_id,
        DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTROADTYE,DEFAULTTYPEOFDOCUMENT
    ]);

    useEffect(() => {
        let isMounted = true; 
        const fetchDataDocumentIdRespProd = async () => {
            try {
            const getData = await helpHttp().get2(ENDPOINT,`form/getlistdocumentidformdi/`,token,
                (formForm.resp_prod_documentid!==undefined && formForm.resp_prod_documentid!==null && formForm.resp_prod_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.resp_prod_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
            if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
                setDocumentIdRespProdToSelect(getData); 
            }
            } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };   
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel7'){
            if (formForm.resp_prod_documentid && formForm.resp_prod_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataDocumentIdRespProd();
            }
        } else{
            setDocumentIdRespProdToSelect(initialDocumentIdToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.resp_prod_documentid,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataTradenameRespProd = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`form/getlisttradenameformdi/`,token,
                    (formForm.resp_prod_tradename!==undefined && formForm.resp_prod_tradename!==null && formForm.resp_prod_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.resp_prod_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setTradenameRespProdToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel7'){
            if (formForm.resp_prod_tradename && formForm.resp_prod_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataTradenameRespProd();
            }
        } else{
            setTradenameRespProdToSelect(initialDocumentIdToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.resp_prod_tradename,expanded]);

    useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeAutDest = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`form/getlistpostalcodeformdi/`,token,
                    (formForm.resp_prod_postalcode_code!==undefined && formForm.resp_prod_postalcode_code!==null && formForm.resp_prod_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.resp_prod_postalcode_code.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeRespProdToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
            if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel7'){
            if (formForm.resp_prod_postalcode_code && formForm.resp_prod_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeAutDest();
            } 
        } else{
            setPostalCodeRespProdToSelect(initialPostalCodesToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.resp_prod_postalcode_code,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormForm]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataNimaRespProd = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`searchdcs/getlistnimas`,token,formForm.resp_prod_store_id, 
                    (formForm.resp_prod_nima!==undefined && formForm.resp_prod_nima!==null && formForm.resp_prod_nima.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.resp_prod_nima.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setRespProdNimaToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel7'){
            if (formForm.resp_prod_store_id && formForm.resp_prod_store_id!==null && formForm.resp_prod_store_id!=="" && formForm.resp_prod_store_id!=="0" && formForm.resp_prod_store_id!==0){
                fetchDataNimaRespProd(); 
            }else{
                setRespProdNimaToSelect(initialNimaToSelect);
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm,expanded,setFormForm,formForm.resp_prod_store_id]);
    
    return(
    (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel7') &&
        <>
            <div className="row p-2"> 
                <div className="form-group"> 
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_DocuentType')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <TextField
                    id="resp_prod_documnettype_id"
                    name="resp_prod_documnettype_id"
                    value={ (formForm.resp_prod_documnettype_id === undefined || formForm.resp_prod_documnettype_id ===null || formForm.resp_prod_documnettype_id ===""
                        || formForm.resp_prod_documnettype_id ==="0" || formForm.resp_prod_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT):formForm.resp_prod_documnettype_id}
                    inputProps={{ style: {width: 100,  fontSize: '18px'}, maxLength: 100 }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                    variant="outlined"
                    onBlur={handleBlurSelectDocumentType_Resp_Prod}
                    onChange={handleChangeSelectDocumentType_Resp_Prod}
                    disabled={!resp_prod_handle_documnettype || hasbeenshared}
                    helperText={errorsForm.resp_prod_documnettype_id!=null && errorsForm.resp_prod_documnettype_id!==""?t(errorsForm.resp_prod_documnettype_id):""}
                    select
                    SelectProps={{
                        native: true,
                        value: (formForm.resp_prod_documnettype_id === undefined || formForm.resp_prod_documnettype_id ===null || formForm.resp_prod_documnettype_id ===""
                            || formForm.resp_prod_documnettype_id ==="0" || formForm.resp_prod_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT): formForm.resp_prod_documnettype_id
                    }}>
                    <option key={0} value=""/>
                    {documentTypesToSelect.map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.name}
                        </option>
                    ))}
                </TextField>  
                {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CIF')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <span style={{ position: "relative" }}>
                     <TextField
                        id="resp_prod_documentid"
                        name="resp_prod_documentid"
                        value={formForm.resp_prod_documentid}
                        onChange={(e) => {
                            setFormForm(prev => ({
                            ...prev,
                            resp_prod_documentid: e.target.value.toUpperCase()
                            }));
                            debouncedHandleSearchDocumentIdResp(e.target.value);
                        }}
                        onKeyDown={handleKeyDownDocumentIdRespProd}
                        onBlur={(event) => {
                            if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                            handleBlur();
                            }
                        }}
                        label={errorsForm.resp_prod_documentid!=null && errorsForm.resp_prod_documentid!==""?t(errorsForm.resp_prod_documentid):t('PlaceHolder_FORM_CIF')}
                        placeholder={t('PlaceHolder_FORM_CIF')}
                        variant="standard"
                        inputProps={{ style: {width: i18n.language==='es'?245:285,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        disabled={!resp_prod_handle_documentid || hasbeenshared}
                    /> 
                    {/* Desplegable dinámico */}
                    {filteredDocumentIdRespProd.length > 0 && (
                        <div
                            className="dropdown-class"
                            style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "750px",
                                overflowY: "auto",
                                width: "150%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                            }}
                            onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                        >
                            {filteredDocumentIdRespProd.map((store, index) => (
                            <MenuItem
                                key={store.id}
                                onClick={() => handleSelectDocumentIdRespProd(store)}
                                style={{
                                    cursor: "pointer",
                                    padding: "8px",
                                    borderBottom: "1px solid #eee",
                                    fontSize: '18px',
                                    backgroundColor:
                                    index === highlightedIndexDocumentIdRespProd ? "#4e73df" : "transparent",
                                    color: index === highlightedIndexDocumentIdRespProd ? "white" : "black",
                                }}
                            >
                                {store.documentid} - {store.tradename}
                            </MenuItem>
                            ))}
                        </div>
                    )}
                </span>  
                &nbsp;&nbsp;
                <IconButton  size="small" className={`deletesmall-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared}  onClick={deleteDateRespProd}>
                    <DeleteIcon style={{fontSize: 28}}/>
                </IconButton>
                &nbsp;&nbsp;
                {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                    <IconButton  size="small" className={`edit-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared}  onClick={searchFormStore}>
                        <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>
                }
                </div>
            </div>
            <div className="row p-2"> 
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_TRADENAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="resp_prod_tradename"
                            name="resp_prod_tradename"
                            value={formForm.resp_prod_tradename}
                            onChange={(e) => {
                                setFormForm(prev => ({
                                ...prev,
                                resp_prod_tradename: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchTradenameResp(e.target.value);
                            }}
                            onKeyDown={handleKeyDownTradenameRespProd}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.resp_prod_tradename!=null && errorsForm.resp_prod_tradename!==""?t(errorsForm.resp_prod_tradename):t('PlaceHolder_FORM_TRADENAME')}
                            placeholder={t('PlaceHolder_FORM_TRADENAME')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?720:696,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            disabled={!resp_prod_handle_tradename || hasbeenshared}
                        />   
                        {/* Desplegable dinámico */}
                        {filteredTradenamedRespProd.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    maxWidth: "750px",
                                    overflowY: "auto",
                                    width: "150%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredTradenamedRespProd.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectTradeNameRespProd(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexTradenamedRespProd ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexTradenamedRespProd ? "white" : "black",
                                    }}
                                >
                                    {store.tradename} - {store.documentid}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span> 
                </div>
            </div>
            {resp_prod_view_name &&
                <div className="row p-2"> 
                    <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="resp_prod_name" 
                        name="resp_prod_name"
                        value={formForm.resp_prod_name}
                        inputProps={{ style: {width: i18n.language==='es'?674:719,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.resp_prod_name!=null && errorsForm.resp_prod_name!==""?t(errorsForm.resp_prod_name):t('PlaceHolder_FORM_NAME')}
                        placeholder={t('PlaceHolder_FORM_NAME')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Resp_Prod}
                        onChange={handleChangeDataEditForm_Resp_Prod}
                        disabled={!resp_prod_handle_name || hasbeenshared}
                    />
                    </div>
                </div> 
            }
            {resp_prod_view_contactname &&
                <div className="row p-2"> 
                    <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CONTACT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="resp_prod_contactname" 
                        name="resp_prod_contactname"
                        value={formForm.resp_prod_contactname}
                        inputProps={{ style: {width: i18n.language==='es'?657:702,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.resp_prod_contactname!=null && errorsForm.resp_prod_contactname!==""?t(errorsForm.resp_prod_contactname):t('PlaceHolder_FORM_CONTACT')}
                        placeholder={t('PlaceHolder_FORM_CONTACT')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Resp_Prod}
                        onChange={handleChangeDataEditForm_Resp_Prod}
                        disabled={!resp_prod_handle_contactname || hasbeenshared}
                    />
                    </div>
                </div> 
            }
            {resp_prod_view_address &&
                <>
                    <div className="row p-2"> 
                        <div className="form-group">
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_RoadType')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                            id="resp_prod_roadtype"
                            name="resp_prod_roadtype"
                            value={ (formForm.resp_prod_roadtype_id === undefined || formForm.resp_prod_roadtype_id ===null || formForm.resp_prod_roadtype_id ===""
                                || formForm.resp_prod_roadtype_id ==="0" || formForm.resp_prod_roadtype_id ===0)?"":formForm.resp_prod_roadtype_id}
                            inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            variant="outlined"
                            onBlur={handleBlurSelectRoadType_Resp_Prod}
                            onChange={handleChangeSelectRoadType_Resp_Prod}
                            disabled={!resp_prod_handle_address || hasbeenshared}
                            helperText={errorsForm.resp_prod_roadtype_id!=null && errorsForm.resp_prod_roadtype_id!==""?t(errorsForm.resp_prod_roadtype_id):""}
                            select
                            SelectProps={{
                                native: true,
                                value: (formForm.resp_prod_roadtype_id === undefined || formForm.resp_prod_roadtype_id ===null || formForm.resp_prod_roadtype_id ===""
                                    || formForm.resp_prod_roadtype_id ==="0" || formForm.resp_prod_roadtype_id ===0)?"": formForm.resp_prod_roadtype_id
                            }}>
                            <option key={0} value=""/>
                            {roadTypesToSelect.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {i18n.language==="es"?option.namees:option.nameen}
                                </option>
                            ))}
                        </TextField>  
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Address')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField
                            id="resp_prod_street" 
                            name="resp_prod_street"
                            value={formForm.resp_prod_street}
                            inputProps={{ style: {width: i18n.language==='es'?361:374,  fontSize: '18px', }, maxLength: 250 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsForm.resp_prod_street!=null && errorsForm.resp_prod_street!==""?t(errorsForm.resp_prod_street):t('PlaceHolder_FORM_Address')}
                            placeholder={t('PlaceHolder_FORM_Address')}
                            variant="standard"
                            onBlur={handleBlurDataEditForm_Resp_Prod}
                            onChange={handleChangeDataEditForm_Resp_Prod}
                            disabled={!resp_prod_handle_address || hasbeenshared}
                        />
                        </div>
                        &nbsp;&nbsp;
                        <IconButton  size="small" className={`deletesmall-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared}  onClick={deleteDataSteetRespProd}>
                            <DeleteIcon style={{fontSize: 28}}/>
                        </IconButton>
                        &nbsp;&nbsp;
                        {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&& formForm.resp_prod_documentid!==undefined && formForm.resp_prod_documentid!=="") ?
                            <IconButton  size="small" className={`edit-${
                                (formForm.resp_prod_store_id===undefined
                                || formForm.resp_prod_store_id===""
                                || formForm.resp_prod_store_id==="0"
                                || formForm.resp_prod_store_id===0 || hasbeenshared)? "noselect-button": "select-button" }`}
                                disabled={(formForm.resp_prod_store_id===undefined
                                || formForm.resp_prod_store_id===""
                                || formForm.resp_prod_store_id==="0"
                                || formForm.resp_prod_store_id===0 || hasbeenshared)}  onClick={searchFormStoreAddress}>
                                <SearchIcon style={{fontSize: 28}}/>
                            </IconButton>:
                            <IconButton  size="small" className="edit-noselect-button" disabled>
                                <SearchIcon style={{fontSize: 28}}/>
                            </IconButton>
                        }
                    </div>
                    <div className="row p-2"> 
                        <div className="form-group">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_PostalCode')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <span style={{ position: "relative" }}>
                                <TextField
                                    id="resp_prod_postalcode_code"
                                    name="resp_prod_postalcode_code"
                                    value={formForm.resp_prod_postalcode_code}
                                    onChange={(e) => {
                                          setFormForm(prev => ({
                                            ...prev,
                                            resp_prod_postalcode_code: e.target.value.toUpperCase()
                                        }));
                                        debouncedHandleSearchPostalCode(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownDPostalCodeRespProd}
                                    onBlur={(event) => {
                                        if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                            const inputPostalCode = formForm.resp_prod_postalcode_code.trim().toUpperCase();
                                            const matchedPostal = postalCodeRespProdToSelect.find((postal) => {
                                            const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                            return normalizedPostal === inputPostalCode;
                                            });

                                            if (matchedPostal) {
                                                setFormForm((prev) => ({
                                                    ...prev,
                                                    resp_prod_postalcode_id: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                                    resp_prod_postalcode_code: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                                    resp_prod_postalcode_name: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                                    resp_prod_province_id: matchedPostal.province_id || Number(DEFAULTPROVINCE), 
                                                    resp_prod_province_name: matchedPostal.province_name || DEFAULTPROVINCE_NAME
                                                }));
                                            } else {
                                                setFormForm((prev) => ({
                                                    ...prev,
                                                    resp_prod_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
                                                    resp_prod_postalcode_code: DEFAULTPOSTALCODE_CODE,
                                                    resp_prod_postalcode_name: DEFAULTPOSTALCODE_NAME,
                                                    resp_prod_province_id: Number(DEFAULTPROVINCE),
                                                    resp_prod_province_name: DEFAULTPROVINCE_NAME
                                                }));
                                            }
                                            setFilteredpostalCodeRespProd([]);
                                            setHighlightedIndexPostalCodeRespProd(-1);
                                        }
                                    }}
                                    label={errorsForm.resp_prod_postalcode_code!=null && errorsForm.resp_prod_postalcode_code!==""?t(errorsForm.resp_prod_postalcode_code):t('Text_FORM_PostalCode')}
                                    placeholder={t('Text_FORM_PostalCode')}
                                    variant="standard"
                                    inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                />  
                                {/* Desplegable dinámico */}
                                {filteredpostalCodeRespProd.length > 0 && (
                                    <div
                                        className="dropdown-class"
                                        style={{
                                            position: "absolute",
                                            left:'0px',
                                            border: "2px solid #4e73df", // Borde azul (#4e73df)
                                            borderRadius: "4px",
                                            marginTop: "4px",
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            width: "700%", 
                                            fontSize: '18px',
                                            backgroundColor: "#f8f9fa", // Fondo gris claro
                                            zIndex: 1000, 
                                        }}
                                        onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                    >
                                        {filteredpostalCodeRespProd.map((postal, index) => (
                                        <MenuItem
                                            key={postal.id}
                                            onClick={() => handleSelectPostalCodeRespProd(postal)}
                                            style={{
                                                cursor: "pointer",
                                                padding: "8px",
                                                borderBottom: "1px solid #eee",
                                                fontSize: '18px',
                                                backgroundColor:
                                                index === highlightedIndexPostalCodeRespProd ? "#4e73df" : "transparent",
                                                color: index === highlightedIndexPostalCodeRespProd ? "white" : "black",
                                            }}
                                        >
                                            {postal.postalcode} - {postal.name} - {postal.province_name}
                                        </MenuItem>
                                        ))}
                                    </div>
                                )}
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Locality')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                                id="resp_prod_postalcode_name" 
                                name="resp_prod_postalcode_name"
                                value={formForm.resp_prod_postalcode_name}
                                inputProps={{ style: {width: i18n.language==='es'?473:503,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.resp_prod_postalcode_name!=null && errorsForm.resp_prod_postalcode_name!==""?t(errorsForm.resp_prod_contactname):t('Text_FORM_Locality')}
                                placeholder={t('Text_FORM_Locality')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Resp_Prod}
                                onChange={handleChangeDataEditForm_Resp_Prod}
                                disabled
                            />   
                        </div>
                    </div>
                    <div className="row p-2"> 
                        <div className="form-group">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Community')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                                id="resp_prod_community_id"
                                name="resp_prod_community_id"
                                value={ (formForm.resp_prod_community_id === undefined || formForm.resp_prod_community_id ===null || formForm.resp_prod_community_id ===""
                                    || formForm.resp_prod_community_id ==="0" || formForm.resp_prod_community_id ===0)?Number(DEFAULTCOMMUNITY):formForm.resp_prod_community_id}
                                inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                variant="outlined"
                                onBlur={handleBlurSelectCommunity_Resp_Prod}
                                onChange={handleChangeSelectCommunity_Resp_Prod}
                                disabled={!resp_prod_handle_address || hasbeenshared}
                                helperText={errorsForm.resp_prod_community_id!=null  && errorsForm.resp_prod_community_id!==""?t(errorsForm.resp_prod_community_id):""}
                                select
                                SelectProps={{
                                    native: true,
                                    value: (formForm.resp_prod_community_id === undefined || formForm.resp_prod_community_id ===null || formForm.resp_prod_community_id ===""
                                        || formForm.resp_prod_community_id ==="0" || formForm.resp_prod_community_id ===0)?Number(DEFAULTCOMMUNITY): formForm.resp_prod_community_id
                                }}>
                                {communityToSelect.map((option) => (
                                    <option key={option.id} value={option.id}>
                                        {i18n.language==="es"?option.namees:option.nameen}
                                    </option>
                                ))}
                            </TextField>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Province')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                                id="resp_prod_province_name" 
                                name="resp_prod_province_name"
                                value={formForm.resp_prod_province_name}
                                inputProps={{ style: {width: i18n.language==='es'?300:305,  fontSize: '18px', }, maxLength: 30 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.resp_prod_province_name!=null && errorsForm.resp_prod_province_name!==""?t(errorsForm.resp_prod_province_name):t('Text_FORM_Province')}
                                placeholder={t('Text_FORM_Province')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Resp_Prod}
                                onChange={handleChangeDataEditForm_Resp_Prod}
                                disabled
                            />
                        </div>
                    </div>
 
                    
                </>
            }    
            { (resp_prod_view_phone || resp_prod_view_email || resp_prod_view_nima) &&
                <div className="row p-2"> 
                    <div className="form-group">
                        {resp_prod_view_phone &&
                            <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Phone')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField
                                    id="resp_prod_phone" 
                                    name="resp_prod_phone"
                                    value={formForm.resp_prod_phone}
                                    inputProps={{ style: {width: i18n.language==='es'?180:180,  fontSize: '18px', }, maxLength: 30 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    label={errorsForm.resp_prod_phone!=null && errorsForm.resp_prod_phone!==""?t(errorsForm.resp_prod_phone):t('PlaceHolder_FORM_Phone')}
                                    placeholder={t('PlaceHolder_FORM_Phone')}
                                    variant="standard"
                                    onBlur={handleBlurDataEditForm_Resp_Prod}
                                    onChange={handleChangeDataEditForm_Resp_Prod}
                                    disabled={!resp_prod_handle_phone || hasbeenshared}
                                />
                                {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                            </>
                        }
                        {resp_prod_view_email &&
                            <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Email')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField
                                    id="resp_prod_email" 
                                    name="resp_prod_email"
                                    value={formForm.resp_prod_email}
                                    inputProps={{ style: {width:  (!resp_prod_view_phone || !resp_prod_view_nima)?(i18n.language==='es'?380:394):(i18n.language==='es'?181:197) ,  fontSize: '18px'}, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    label={errorsForm.resp_prod_email!=null && errorsForm.resp_prod_email!==""?t(errorsForm.resp_prod_email):t('PlaceHolder_FORM_Email')}
                                    placeholder={t('PlaceHolder_FORM_Email')}
                                    variant="standard"
                                    onBlur={handleBlurDataEditForm_Resp_Prod}
                                    onChange={handleChangeDataEditForm_Resp_Prod}
                                    disabled={!resp_prod_handle_email || hasbeenshared}
                                />
                                {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                            </>
                        }
                        {resp_prod_view_nima &&
                            <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NIMA')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <span style={{ position: "relative" }}>
                                    <TextField
                                        id="resp_prod_nima"
                                        name="resp_prod_nima"
                                        value={formForm.resp_prod_nima}
                                        onChange={(e) => {
                                            setFormForm(prev => ({
                                            ...prev,
                                            resp_prod_nima: e.target.value.toUpperCase()
                                            }));
                                            debouncedHandleSearchRespProdNima(e.target.value);
                                        }}
                                        onKeyDown={handleKeyDownRespProdNima}
                                        onBlur={(event) => {
                                            if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                            handleBlur();
                                            }
                                        }}
                                        label={errorsForm.resp_prod_nima!=null && errorsForm.resp_prod_nima!==""?t(errorsForm.resp_prod_nima):t('PlaceHolder_FORM_NIMA')}
                                        placeholder={t('PlaceHolder_FORM_NIMA')}
                                        variant="standard"
                                        inputProps={{ style: {width: (!resp_prod_view_phone || !resp_prod_view_email)?133:133,  fontSize: '18px'}, maxLength: 50 }}
                                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                        disabled={!resp_prod_handle_nima || hasbeenshared}
                                    />  
                                    {/* Desplegable dinámico */}
                                    {filteredRespProdNima.length > 0 && (
                                        <div
                                            className="dropdown-class"
                                            style={{
                                                position: "absolute",
                                                left:'0px',
                                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                                borderRadius: "4px",
                                                marginTop: "4px",
                                                maxHeight: "200px",
                                                maxWidth: "750px",
                                                overflowY: "auto",
                                                width: "100%",
                                                fontSize: '18px',
                                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                                zIndex: 1000,
                                            }}
                                            onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                        >
                                            {filteredRespProdNima.map((nt, index) => (
                                            <MenuItem
                                                key={nt.id}
                                                onClick={() => handleSelectRespProdNima(nt)}
                                                style={{
                                                    cursor: "pointer",
                                                    padding: "8px",
                                                    borderBottom: "1px solid #eee",
                                                    fontSize: '18px',
                                                    backgroundColor:
                                                    index === highlightedIndexRespProdNima ? "#4e73df" : "transparent",
                                                    color: index === highlightedIndexRespProdNima ? "white" : "black",
                                                }}
                                            >
                                                {nt.nima}
                                            </MenuItem>
                                            ))}
                                        </div>
                                    )}
                            </span>
                            &nbsp;&nbsp;
                            {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formForm.resp_prod_documentid!==undefined && formForm.resp_prod_documentid!=="") ?
                                <IconButton  size="small" className={`edit-${
                                    (formForm.resp_prod_store_id===undefined
                                    || formForm.resp_prod_store_id===""
                                    || formForm.resp_prod_store_id==="0"
                                    || formForm.resp_prod_store_id===0 || hasbeenshared)? "noselect-button": "select-button" }`}
                                    disabled={(formForm.resp_prod_store_id===undefined
                                    || formForm.resp_prod_store_id===""
                                    || formForm.resp_prod_store_id==="0"
                                    || formForm.resp_prod_store_id===0 || hasbeenshared)}  onClick={searchFormStoreNimaAddress}>
                                    <SearchIcon style={{fontSize: 28}}/>
                                </IconButton>:
                               <IconButton  size="small" className="edit-noselect-button" disabled>
                                    <SearchIcon style={{fontSize: 28}}/>
                                </IconButton>
                            }
                            </>
                        }
                    </div>
                </div>  
            }
            { (resp_prod_view_inscription || resp_prod_view_opt) &&
                <div className="row p-2"> 
                    <div className="form-group">
                    {resp_prod_view_inscription &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_INSCRIPTION')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                                id="resp_prod_inscription" 
                                name="resp_prod_inscription"
                                value={formForm.resp_prod_inscription}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                inputProps={{ style: {width: !resp_prod_view_opt?350:250,  fontSize: '18px'}, maxLength: 50 }}
                                label={errorsForm.resp_prod_inscription!=null && errorsForm.resp_prod_inscription!==""?t(errorsForm.resp_prod_inscription):t('PlaceHolder_FORM_INSCRIPTION')}
                                placeholder={t('PlaceHolder_FORM_INSCRIPTION')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Resp_Prod}
                                onChange={handleChangeDataEditForm_Resp_Prod}
                                disabled={!resp_prod_handle_inscription || hasbeenshared}
                            />
                            {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                        </>
                    }
                    {resp_prod_view_opt &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_OPT')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                                id="resp_prod_opt"
                                name="resp_prod_opt"
                                value={ (formForm.resp_prod_opt === undefined || formForm.resp_prod_opt ===null || formForm.resp_prod_opt ===""
                                    || formForm.resp_prod_opt ==="0" || formForm.resp_prod_opt ===0)?0:formForm.resp_prod_opt}
                                inputProps={{ style: {width: i18n.language==='es'?170:147,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                variant="outlined"
                                onBlur={handleBlurDataEditForm_Resp_Prod}
                                onChange={handleChangeDataEditForm_Resp_Prod} 
                                helperText={errorsForm.resp_prod_opt!=null?t(errorsForm.resp_prod_opt):""}
                                disabled={!resp_prod_handle_opt || hasbeenshared}
                                select
                                SelectProps={{
                                    native: true,
                                    value: (formForm.resp_prod_opt === undefined || formForm.resp_prod_opt ===null || formForm.resp_prod_opt ===""
                                        || formForm.resp_prod_opt ==="0" || formForm.resp_prod_opt ===0)?0: formForm.resp_prod_opt
                                }}>
                                <option key={0} value=""/>
                                {optTypeToSelect.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {option.code} - {option.namees.substring(0,20)}
                                </option>
                                ))}
                            </TextField>   
                        </>
                    }
                    </div>
                </div> 
            }

            { (resp_prod_view_cnae || resp_prod_view_licenseplate) &&
                <div className="row p-2"> 
                    <div className="form-group">
                    {resp_prod_view_cnae &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CNAE')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                                id="resp_prod_cnae" 
                                name="resp_prod_cnae"
                                value={formForm.resp_prod_cnae}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                inputProps={{ style: {width: !resp_prod_view_licenseplate?355:250,  fontSize: '18px'}, maxLength: 100 }}
                                label={errorsForm.resp_prod_cnae!=null && errorsForm.resp_prod_cnae!==""?t(errorsForm.resp_prod_cnae):t('PlaceHolder_FORM_CNAE')}
                                placeholder={t('PlaceHolder_FORM_CNAE')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Resp_Prod}
                                onChange={handleChangeDataEditForm_Resp_Prod}
                                disabled={!resp_prod_handle_cnae || hasbeenshared}
                            />
                            {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                        </>
                    }
                    {resp_prod_view_licenseplate &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Vehicles')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField
                                id="resp_prod_licenseplate" 
                                name="resp_prod_licenseplate"
                                value={formForm.resp_prod_licenseplate}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                inputProps={{ style: {width: !resp_prod_view_cnae?313:(i18n.language==='es'?313:324),  fontSize: '18px'}, maxLength: 100 }}
                                label={errorsForm.resp_prod_licenseplate!=null && errorsForm.resp_prod_licenseplate!==""?t(errorsForm.resp_prod_licenseplate):t('PlaceHolder_FORM_Vehicles')}
                                placeholder={t('PlaceHolder_FORM_Vehicles')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Resp_Prod}
                                onChange={handleChangeDataEditForm_Resp_Prod}
                                disabled={!resp_prod_handle_licenseplate || hasbeenshared}
                            />
                            &nbsp;&nbsp;
                            <IconButton  size="small" className={`deletesmall-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared} onClick={deleteDataVehicleRespProd}>
                                <DeleteIcon style={{fontSize: 28}}/>
                            </IconButton>
                            &nbsp;&nbsp;
                            {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                                <IconButton  size="small" className={`edit-${
                                    (formForm.resp_prod_store_id===undefined
                                    || formForm.resp_prod_store_id===""
                                    || formForm.resp_prod_store_id==="0"
                                    || formForm.resp_prod_store_id===0 || hasbeenshared)? "noselect-button": "select-button" }`}
                                    disabled={(formForm.resp_prod_store_id===undefined
                                    || formForm.resp_prod_store_id===""
                                    || formForm.resp_prod_store_id==="0"
                                    || formForm.resp_prod_store_id===0 || hasbeenshared)}  onClick={searchFormVehicles}>
                                <SearchIcon style={{fontSize: 28}}/>
                              </IconButton>
                            } 
                        </>
                    }
                    </div>
                </div> 
            }
            {resp_prod_view_economicactivity &&
                <div className="row p-2"> 
                    <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Economicactivity')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="resp_prod_economicactivity" 
                        name="resp_prod_economicactivity"
                        value={formForm.resp_prod_economicactivity}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        inputProps={{ style: {width: i18n.language==='es'?659:685,  fontSize: '18px'}, maxLength: 100 }}
                        label={errorsForm.resp_prod_economicactivity!=null && errorsForm.resp_prod_economicactivity!==""?t(errorsForm.resp_prod_economicactivity):t('PlaceHolder_FORM_Economicactivity')}
                        placeholder={t('PlaceHolder_FORM_Economicactivity')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Resp_Prod}
                        onChange={handleChangeDataEditForm_Resp_Prod}
                        disabled={!resp_prod_handle_economicactivity || hasbeenshared}
                    />
                    </div>
                </div> 
            }
            <FormSearchStores
                showModalSearchStores={showModalSearchStores}
                setShowModalSearchStores={setShowModalSearchStores}
                selectStores={"Resp_Prod"}
                setFormForm={setFormForm}
            />
            <FormSearchStoresAddresses
                showModalSearchStoresAddress={showModalSearchStoresAddress}
                setShowModalSearchStoresAddress={setShowModalSearchStoresAddress}
                selectStores={"Resp_Prod"}
                setFormForm={setFormForm}
                titleTable={formForm.resp_prod_tradename}
                store_id={formForm.resp_prod_store_id}
                priority={7}
            />
            <FormSearchStoresNimaAddresses
                showModalSearchStoresNimaAddress={showModalSearchStoresNimaAddress}
                setShowModalSearchStoresNimaAddress={setShowModalSearchStoresNimaAddress}
                selectStores={"Resp_Prod"}
                setFormForm={setFormForm}
                titleTable={formForm.resp_prod_tradename}
                store_id={formForm.resp_prod_store_id} 
            />
            <FormSearchStoreVehicles
                showModalSearchVehicles={showModalSearchVehicles}
                setShowModalSearchVehicles={setShowModalSearchVehicles}
                selectStores={"Resp_Prod"}
                setFormForm={setFormForm}
                titleTable={formForm.resp_prod_tradename}
                store_id={formForm.resp_prod_store_id}
            />

        </> 
    )
}

FormCreateOrEditRespProd.propTypes = {
    formForm: PropTypes.object.isRequired,
    setFormForm: PropTypes.func.isRequired,
    setIsLoadingErrorData: PropTypes.func.isRequired,
    errorsForm: PropTypes.object.isRequired,
    setErrorsForm: PropTypes.func.isRequired,
    validateFormForm: PropTypes.func.isRequired,
    documentTypesToSelect: PropTypes.array.isRequired,
    roadTypesToSelect: PropTypes.array.isRequired,
    communityToSelect: PropTypes.array.isRequired,
    optTypeToSelect: PropTypes.array.isRequired,
    hasbeenshared: PropTypes.bool.isRequired
  };
  
  export default FormCreateOrEditRespProd;

